import { Form} from "antd";
import React, { useContext,} from 'react';
import { Settings } from './Settings';
import { getFinalNameAndValue } from '@/hooks/useNameOfForm';
import { useNode,FormContext } from 'wsc-react-custom-form';

export const FormValues = ({ names, hidden, ...props }) => {
    const { formdata } = useContext(FormContext);

    const {
        connectors: { connect },
    } = useNode((node) => ({
        selected: node.events.selected,
    }));

    if (!names || !Array.isArray(names) || names.length === 0) return null;

    return <div ref={connect}>
        {
            names.map(item => {
                const {name, value} = getFinalNameAndValue(item, formdata);
                return (
                    <Form.Item
                        key={name}
                        label={name}
                        name={name}
                        initialValue={value}
                        disabled
                        hidden={hidden==='true'}
                    />
                );
            })
        }
    </div>

};

FormValues.category = "表单";
// FormValues.thumb = "https://via.placeholder.com/300x200.png";

FormValues.craft = {
    displayName: 'FormValues',
    props: {
        names: [
            'xxx',
            'yyy'
        ],
        hidden: 'true',
    },
    related: {
        toolbar: Settings,
    },
};